import { defineMessages } from 'react-intl';

const scope = 'app.workspace';

export default defineMessages({
  projects: {
    id: `${scope}.projects`,
    defaultMessage: 'Projects',
  },
  classes: {
    id: `${scope}.classes`,
    defaultMessage: 'Classes',
  },
  publications: {
    id: `${scope}.publications`,
    defaultMessage: 'Publications',
  },
  importHistory: {
    id: `${scope}.importHistory`,
    defaultMessage: 'Import history',
  },
});